import { render, staticRenderFns } from "./appVersion.vue?vue&type=template&id=f4116c0c&scoped=true"
import script from "./appVersion.vue?vue&type=script&lang=js"
export * from "./appVersion.vue?vue&type=script&lang=js"
import style0 from "./appVersion.vue?vue&type=style&index=0&id=f4116c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4116c0c",
  null
  
)

export default component.exports